/**
 * Vite entry: boot app with provider stack and TanStack Router.
 */
import '~/global.css';

import { RouterProvider } from '@tanstack/react-router';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { bootstrap } from '~/app/clientBootstrap';
import { AppProviders } from '~/app/store';
import { router } from '~/router';

bootstrap();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root');
const root = createRoot(rootEl);
root.render(
  <AppProviders>
    <RouterProvider router={router} />
  </AppProviders>,
);
